import { capitalize } from '@material-ui/core';
import { DateTime } from 'luxon';
import { EXPORT_CONTINUITY_OF_CARE_URL, EXPORT_HEALTH_SURVEILLANCE_URL, EXPORT_IMMUNIZATION_URL, EXPORT_REFERRAL_URL, MoreMenuTitles, } from '../service/legacy/types';
export var formatPatientName = function (patient) {
    var firstName = patient.firstName.toLowerCase();
    var lastName = patient.lastName.toLowerCase();
    var hasMiddle = !!patient.middleName;
    if (hasMiddle) {
        var middleName = patient.middleName.toLowerCase();
        return capitalize(firstName) + " " + capitalize(middleName) + " " + capitalize(lastName);
    }
    return capitalize(firstName) + " " + capitalize(lastName);
};
export var formatISODateShort = function (isoDate) {
    var _a;
    try {
        var date = DateTime.fromISO(isoDate);
        return date.toLocaleString(DateTime.DATE_SHORT);
    }
    catch (error) {
        (_a = window.rollbar) === null || _a === void 0 ? void 0 : _a.error(error);
        return '';
    }
};
export var formatPatientInsurance = function (patient) {
    var primaryInsurance = patient.primaryInsurance, secondaryInsurance = patient.secondaryInsurance;
    if (primaryInsurance && secondaryInsurance) {
        return primaryInsurance + " (primary), " + secondaryInsurance;
    }
    return primaryInsurance || secondaryInsurance || '';
};
export var formatPatientAddress = function (patient) {
    var address = "" + patient.address1;
    if (!!patient.address2) {
        address = address + ", " + patient.address2;
    }
    return address + ", " + patient.city + ", " + patient.state + " " + patient.zipCode;
};
export var formatPatientBalance = function (balance) {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    return formatter.format(balance);
};
export var formatFileName = function (fileName) {
    return fileName.substring(0, fileName.lastIndexOf('.')) || fileName;
};
export var getExportUrl = function (exportHeaderTitle) {
    switch (exportHeaderTitle) {
        case MoreMenuTitles.Immunization:
            return EXPORT_IMMUNIZATION_URL;
        case MoreMenuTitles.Surveillance:
            return EXPORT_HEALTH_SURVEILLANCE_URL;
        case MoreMenuTitles.Referral:
            return EXPORT_REFERRAL_URL;
        case MoreMenuTitles.Continuity:
            return EXPORT_CONTINUITY_OF_CARE_URL;
        default:
            return '';
    }
};
export var getPhotoUploadHeaderText = function (patient, hasPhoto) {
    var addOrEdit = hasPhoto ? 'Edit' : 'Add a';
    var headerText = addOrEdit + " Photo";
    if (patient) {
        headerText = headerText + " of " + formatPatientName(patient);
    }
    return headerText;
};
export var refreshPage = function () {
    window.location.reload();
};
export var getAgeView = function (age, months) {
    if (age >= 18)
        return age + " yo";
    else if (months > 0 && age > 0)
        return age + " years, " + months + " months old";
    else if (months > 0 && age === 0)
        return months + " months old";
    else
        return age + " years old";
};
export var getCachedDataContext = function (cachedDate) {
    return { isCachedDataDisplayed: true, lastCachedDate: cachedDate };
};
